import { CockpitRow } from '../../../components/cockpitRow'

interface IProps {
  label: string
  count: number
  meta?: string
  onClick: () => void
}
export const DocumentsGroupedRow = ({ label, count, meta, onClick }: IProps) => (
  <CockpitRow
    title={label}
    description={meta}
    count={count}
    chevron
    ariaLabel={`${count} ${label}${meta ? ` · ${meta}` : ''}`}
    onSelect={onClick}
  />
)
